export default {
    students: [
        {
            id: 1,
            name: 'Lewis Miles',
            email: 'sara@benton.li',
            avatar_url: 'https://bulma.io/images/placeholders/64x64.png',
        },
        {
            id: 2,
            name: 'Peggy Bowers',
            email: 'sharon@weber.lk',
            avatar_url: 'https://bulma.io/images/placeholders/64x64.png',
        },
        {
            id: 3,
            name: 'Stacy Whitehead',
            email: 'james@palmer.mw',
            avatar_url: 'https://bulma.io/images/placeholders/64x64.png',
        },
        {
            id: 4,
            name: 'Katherine Fischer',
            email: 'dianne@currie.gf',
            avatar_url: 'https://bulma.io/images/placeholders/64x64.png',
        },
        {
            id: 5,
            name: 'Mike Powers',
            email: 'victor@sellers.ug',
            avatar_url: 'https://bulma.io/images/placeholders/64x64.png',
        },
        {
            id: 6,
            name: 'Alex Blair',
            email: 'toni@morgan.mt',
            avatar_url: 'https://bulma.io/images/placeholders/64x64.png',
        },
        {
            id: 7,
            name: 'Rhonda Eaton',
            email: 'justin@freeman.ps',
            avatar_url: 'https://bulma.io/images/placeholders/64x64.png',
        },
        {
            id: 8,
            name: 'Kim Manning',
            email: 'beth@puckett.eh',
            avatar_url: 'https://bulma.io/images/placeholders/64x64.png',
        },
        {
            id: 9,
            name: 'Willie Hines',
            email: 'lloyd@frederick.rw',
            avatar_url: 'https://bulma.io/images/placeholders/64x64.png',
        },
        {
            id: 10,
            name: 'Gretchen Singleton',
            email: 'malcolm@grossman.kg',
            avatar_url: 'https://bulma.io/images/placeholders/64x64.png',
        },
        {
            id: 11,
            name: 'Stacy Glover',
            email: 'dorothy@sanchez.ss',
            avatar_url: 'https://bulma.io/images/placeholders/64x64.png',
        },
        {
            id: 12,
            name: 'Peter Kang',
            email: 'alex@shaffer.fm',
            avatar_url: 'https://bulma.io/images/placeholders/64x64.png',
        },
        {
            id: 13,
            name: 'Patrick Lyons',
            email: 'rick@nelson.tf',
            avatar_url: 'https://bulma.io/images/placeholders/64x64.png',
        },
        {
            id: 14,
            name: 'Christian MacDonald',
            email: 'lois@hoover.sr',
            avatar_url: 'https://bulma.io/images/placeholders/64x64.png',
        },
        {
            id: 15,
            name: 'Sara Mack',
            email: 'jennifer@warren.dz',
            avatar_url: 'https://bulma.io/images/placeholders/64x64.png',
        },
        {
            id: 16,
            name: 'Gretchen May',
            email: 'victor@daly.gb',
            avatar_url: 'https://bulma.io/images/placeholders/64x64.png',
        },
        {
            id: 17,
            name: 'Judy McCormick',
            email: 'mike@barton.fi',
            avatar_url: 'https://bulma.io/images/placeholders/64x64.png',
        },
        {
            id: 18,
            name: 'Dana Pearson',
            email: 'kara@hill.dk',
            avatar_url: 'https://bulma.io/images/placeholders/64x64.png',
        },
        {
            id: 19,
            name: 'Lewis Copeland',
            email: 'erica@mcfarland.fk',
            avatar_url: 'https://bulma.io/images/placeholders/64x64.png',
        },
        {
            id: 20,
            name: 'Laura McConnell',
            email: 'natalie@scarborough.ie',
            avatar_url: 'https://bulma.io/images/placeholders/64x64.png',
        },
    ],
};
